// extracted by mini-css-extract-plugin
export default {"social-links":"SocialLinks_social-links__R6-uJ"};